
define('text!pages/news_form/news_form_page_template.html',[],function () { return '<div class="news-form-page">\r\n\r\n  <div class="page-title panel">\r\n    <p><%- _.t(\'page_titles.edit_news_item\') %></p>\r\n  </div>\r\n\r\n  <div class="news-form-page-content"></div>\r\n\r\n</div>\r\n';});

